import {
  GET_PHASES,
  GET_EXTERNAL_COSTCODES,
  GET_ALL_PROJECTS,
  GET_VENDORS,
  GET_CUSTOMERS,
  GET_ALL_USERS,
  GET_EQUIPMENT,
  GET_PROJECT_SCHEDULE_OF_VALUES,
  GET_SCHEDULE_OF_VALUE_SECTIONS,
  GET_LABELS,
  GET_LIGHTWEIGHT_FORMS,
  GET_GLOBAL_ADDRESS_BOOK,
  GET_BUCKETS,
  GET_PROJECT_EQUIPMENT,
} from '../../../state/actionTypes';
import ExternalFormService from './externalForm.service';

export const getExternalPhases = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getAllPhases(templateId);
  if (!data) return;
  dispatch({ type: GET_PHASES, payload: { phases: data } });
};

export const getExternalCostcodes = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getAllCostcodes(templateId);
  if (!data) return;
  dispatch({ type: GET_EXTERNAL_COSTCODES, payload: data });
};

export const getExternalProjects = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getAllProjects(templateId);
  if (!data) return;
  dispatch({ type: GET_ALL_PROJECTS, payload: { projects: data } });
};

export const getExternalVendors = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getAllVendors(templateId);
  if (!data) return;
  dispatch({ type: GET_VENDORS, payload: { vendors: data } });
};

export const getExternalCustomers = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getAllCustomers(templateId);
  if (!data) return;
  dispatch({ type: GET_CUSTOMERS, payload: { customers: data } });
};

export const getExternalUsers = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getAllUsers(templateId);
  if (!data) return;
  dispatch({ type: GET_ALL_USERS, payload: { users: data } });
};

export const getExternalEquipment = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getAllEquipment(templateId);
  if (!data) return;
  dispatch({ type: GET_EQUIPMENT, payload: { equipment: data } });
};

export const getExternalProjectEquipment = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getProjectEquipment(templateId);
  if (!data) return;
  dispatch({ type: GET_PROJECT_EQUIPMENT, payload: data });
};

export const getExternalScheduleOfValues = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getAllScheduleOfValues(templateId);
  if (!data) return;
  dispatch({ type: GET_PROJECT_SCHEDULE_OF_VALUES, payload: { scheduleOfValues: data } });
};

export const getExternalScheduleOfValueSections = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getAllScheduleOfValueSections(templateId);
  if (!data) return;
  dispatch({ type: GET_SCHEDULE_OF_VALUE_SECTIONS, payload: { scheduleOfValueSections: data } });
};

export const getExternalLabels = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getLabels(templateId);
  if (!data) return;
  dispatch({ type: GET_LABELS, payload: data });
};

export const getExternalLightWeightForms = (templateId, query) => async (dispatch) => {
  const { data } = await ExternalFormService.getLightWeightForms(templateId, query);
  if (!data) return;
  dispatch({
    type: GET_LIGHTWEIGHT_FORMS,
    payload: {
      forms: data,
      templateId: query?.templateId,
      subContractTemplateId: query?.subContractTemplateId,
    },
  });
};

export const getExternalContacts = (templateId) => async (dispatch) => {
  const { data } = await ExternalFormService.getContacts(templateId);
  if (!data) return;
  dispatch({ type: GET_GLOBAL_ADDRESS_BOOK, payload: { globalAddressBooks: data } });
};

export const getExternalBuckets = (templateId, query) => async (dispatch) => {
  const { data } = await ExternalFormService.getBuckets(templateId, query);
  if (!data) return;
  dispatch({
    type: GET_BUCKETS,
    payload: {
      data,
      query,
    },
  });
};
